import React, { Component } from 'react';
import onClickOutside from 'react-onclickoutside';
import style from './TrackSelector.css';
import { buildAssetUrl } from '../../helpers';
const defaultAvatarURL = 'assets/images/logos/_a_transparent.svg';
const VisToggle = ({ visible = true, toggleVisibility }) => (React.createElement("div", { className: style.visToggle, onClick: e => {
        toggleVisibility();
        e.stopPropagation();
    } },
    React.createElement("svg", { width: '24', height: '24', fill: 'none', stroke: '#FFF', strokeWidth: '2' },
        React.createElement("path", { d: 'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z' }),
        React.createElement("circle", { cx: '12', cy: '12', r: '3' }),
        visible ? null : React.createElement("line", { x1: '0', y1: '24', x2: '24', y2: '0' }))));
class TrackSelector extends Component {
    componentWillMount() {
        this.setState({ filter: false });
    }
    filter() {
        if (!this.state.filter)
            return this.props.tracks;
        return this.props.tracks.filter(t => {
            if (!t.avatar || !t.avatar.name)
                return false;
            return t.avatar.name.toLowerCase().includes(this.state.filter.toLowerCase());
        });
    }
    handleClickOutside() {
        this.props.closeMenu();
    }
    render() {
        return (React.createElement("div", { className: style.selectorWrapper },
            React.createElement("input", { type: 'text', className: style.filter, placeholder: 'Filter', onChange: evt => {
                    this.setState({ filter: evt.target.value });
                } }),
            React.createElement("ul", { className: style.list }, this.filter().map(track => (React.createElement("li", { key: track.activityId, onClick: () => {
                    if (!track.show)
                        return;
                    this.props.setTarget(track.activityId);
                    this.props.closeMenu();
                }, className: `${style.track} ${track.show ? '' : style.hidden} ${track.active ? style.active : ''}` },
                React.createElement("img", { style: { backgroundColor: track.color }, src: track.avatar.image || buildAssetUrl(defaultAvatarURL), className: style.img, alt: 'Avatar name' }),
                React.createElement("span", null,
                    track.avatar.name,
                    " "),
                React.createElement(VisToggle, { visible: track.show, toggleVisibility: () => {
                        this.props.toggleVisibility(track.activityId);
                        if (track.active) {
                            const newTarget = this.props.tracks.find(t => t.show && t !== track);
                            if (newTarget)
                                this.props.setTarget(newTarget.activityId);
                        }
                    } })))))));
    }
}
export const TrackSelectorButton = ({ count, setModal, hideElements }) => {
    if (count <= 1 || hideElements.includes('trackSelector')) {
        return null;
    }
    return (React.createElement("a", { onClick: () => setModal('TrackSelector'), className: style.TrackSelectorButton, "data-numtracks": count },
        React.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '20', height: '23', viewBox: '0 0 20 23' },
            React.createElement("g", { fill: 'none', fillRule: 'evenodd', transform: 'translate(-10 -8)' },
                React.createElement("rect", { width: '40', height: '40' }),
                React.createElement("g", { stroke: 'white', strokeWidth: '2', transform: 'translate(11 9)' },
                    React.createElement("path", { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M0,8 C0,8 0,8.76160653e-16 9,0 C18,0 18,8 18,8', transform: 'translate(0 13)' }),
                    React.createElement("circle", { cx: '9', cy: '4.5', r: '4.5' }))))));
};
export default onClickOutside(TrackSelector);
